import { render, staticRenderFns } from "./PerformanceDetailComponent.vue?vue&type=template&id=12c40b84"
import script from "./PerformanceDetailComponent.js?vue&type=script&lang=js&external"
export * from "./PerformanceDetailComponent.js?vue&type=script&lang=js&external"
import style0 from "./PerformanceDetailComponent.vue?vue&type=style&index=0&id=12c40b84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports